export default class FormHandler {

    constructor(
        apiUrl,
        formId,
        fieldArray,
        templateName = 3,
        copyToEmail = '',
        recaptchaSubmitFnName = 'recaptchaSubmitFn',
    ) {

        this.URL = apiUrl;
        this.formId = formId;
        this.form = document.getElementById(formId);
        this.templateName = templateName;
        this.recaptchaFnName = recaptchaSubmitFnName;
        this.captchaValidationFired = false;
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.submitButtonContent = this.submitButton.innerHTML
        this.fieldArray = fieldArray;
        this.copyToEmail = copyToEmail
        this.init()

    }

    init() {
        this.checkBeforeRender();
    }

    checkBeforeRender() {
        if (this.form) {
            this.setCaptcha();
            this.observeCaptcha();
            this.attachEvents();
        }
    }

    observeCaptcha() {
        const domObserver =  new MutationObserver(() => {
            const iframe = document.querySelector("iframe[src^=\"https://www.google.com/recaptcha\"][src*=\"bframe\"]");

            if (iframe) {
                const captchaBackground = iframe.parentNode?.parentNode?.firstChild;
                captchaBackground?.addEventListener("click", () => this.bgcCaptchaHandle());
            }
        });

        domObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
    }

    attachEvents() {
        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                this.runCaptcha();
                if (!this.captchaValidationFired) {
                    this.sendAfterCaptchaValidation();
                }
            });
        }
    }


    startSending() {
        this.handleSpinnerShow(true);
    }

    setCaptcha() {
        window[this.recaptchaFnName] = (token) => {
            const responseInputList = document.querySelectorAll(`[data-response-token]`);
            responseInputList.forEach(responseInput => {
                responseInput.dataset.responseToken = token;
            });
        };
    }

    runCaptcha() {
        grecaptcha.execute();
    }

    sendAfterCaptchaValidation() {
        this.captchaValidationFired = true;
        let timer = 0;

        const interval = setInterval(() => {
            timer++;
            const response = document.querySelector(`#${this.formId} [data-response-token]`).dataset.responseToken;

            if (response) {
                clearInterval(interval);
                timer = false;
                this.startSending();
                this.sendForm(response);
                this.resetCaptcha();
            }

            if (timer === 120 && !response) {
                clearInterval(interval);
                this.resetCaptcha();
                this.showAlert('danger', 'captchaInfo');
            };


        }, 1000);
    }

    resetCaptcha() {
        grecaptcha.reset();
        const responseInput = document.querySelector(`#${this.formId} [data-response-token]`);
        responseInput.dataset.responseToken = '';
    }
    bgcCaptchaHandle() {
        this.resetCaptcha();
    }

    sendForm(response) {
        const pageLang = document.documentElement.lang === 'pl' ? 'pl' : 'en';

        const body = this.fieldArray.reduce((body, el) => {
            body[el] = this.form.querySelector(`[name="${el}"]`).value
            return body
        }, {})

        this.submitButton.setAttribute('disabled', 'true')

        fetch(this.URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            mode: 'cors',
            body: JSON.stringify({
                language: pageLang,
                copyToUserEmail: this.copyToEmail,
                templateName: this.templateName,
                templateParameters: {
                    ...body
                },
                gRecaptchaResponse: response
            })
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                this.handleSpinnerShow(true);
                this.showAlert('danger', 'errorInfo');
                throw Error(response.statusText);
            })
            .then (() => {
                this.showAlert('success', 'successInfo');
            })
            .catch(error => {
                console.log(error + ' something went wrong');
                this.showAlert('danger', 'errorInfo');
            });
    }

    handleSpinnerShow(show = false) {
        const spinner = `
            <div class="spinner" role="status">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="45"/></svg>
                <span class="sr-only">Loading...</span>
             </div>
        `

        this.submitButton.innerHTML = show ? spinner : this.submitButtonContent
    }

    showAlert(alertType, dataName) {
        const alert = document.querySelector(`#${this.formId} .alert`);

        if (alert) {
            const infoText = alert.dataset[dataName];

            this.handleSpinnerShow();

            alert.innerHTML =
                `
                    <div class="icon" aria-hidden="true"></div>
                    ${infoText}
                `;
            alert.classList.add(`alert-${alertType}`);
            alert.classList.remove('d-none');
        }

        this.submitButton.removeAttribute('disabled');
    }

}
